function navigationService($translate, _) {
  const navigationTree = {
    title: $translate.instant('WEBSKED_USER_PROFILE'),
    sref: 'profile.overview',
    id: 'profile.overview',
    tree: [
      {
        title: $translate.instant('NOTIFICATIONS'),
        sref: 'profile.notifications',
        id: 'profile.notifications',
        tree: [
          {
            title: $translate.instant('CREATE_NOTIFICATION'),
            sref: 'profile.createnotification',
            id: 'profile.createnotification'
          },
          {
            title: $translate.instant('UPDATE_NOTIFICATION'),
            sref: 'profile.editnotification',
            id: 'profile.editnotification'
          }
        ]
      },
      {
        title: $translate.instant('PREFERENCES'),
        sref: 'profile.preferences',
        id: 'profile.preferences'
      }
    ]
  };

  function processNavigationTree(treeItem) {
    _.forOwn(treeItem, (value, key) => {
      if (key === 'tree') {
        _.each(value, (treeSub) => {
          const treeSubItem = treeSub;
          treeSubItem.parent = treeItem;
          processNavigationTree(treeSubItem);
        });
      }
    });
  }

  function findLeaf(obj, key, value) {
    if (_.has(obj, key) && obj[key] === value) {
      return [obj];
    }

    return _.flatten(_.map(obj, (v, k) => (typeof v === 'object' && k !== 'parent' ? findLeaf(v, key, value) : [])), true);
  }

  function unwind(object, stack) {
    stack.push(object);
    if (object.parent) {
      unwind(object.parent, stack);
    }
  }

  const service = {
    currentNodeIdProfile: null,
    currentNodeIdGroup: null,
    breadcrumbs: []
  };

  service.bakeBreadcrumbs = () => {
    if (!service.currentNodeIdProfile) return;

    const leafs = findLeaf(navigationTree, 'id', service.currentNodeIdProfile);
    if (!leafs || !leafs.length) {
      return;
    }
    const crumbs = [];
    unwind(leafs[0], crumbs);
    service.breadcrumbs = crumbs.reverse();
  };

  service.navigateProfile = (id) => {
    service.currentNodeIdProfile = id;
    service.bakeBreadcrumbs();
  };

  service.navigateGroup = (id) => {
    service.currentNodeIdGroup = id;
  };

  processNavigationTree(navigationTree);

  return service;
}

const arr = [
  '$translate',
  '_',
  navigationService
];

module.exports = (ngModule) => {
  ngModule.factory('navigationService', arr);
};
